module.exports = __webpack_public_path__ + "static/media/Exeggcute_gaussian2.167abef9.png";